import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Main from './Main'
function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
